import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], order = '', column: string = ''): any[] {
    console.log(value, order, column);
    console.log(value, order, column);
    if (!value || order === '' || !order) { console.log(value); return value; } // no array
    if (value.length <= 1) { console.log(value); return value; } // array with only one item
    if (!column || column === '') {
      if (order === 'asc') { console.log(value.sort()); return value.sort(); }
      else{ console.log(value.sort().reverse()); return value.sort().reverse(); }
    } // sort 1d array

    console.log(value, [column], [order]);
    return orderBy(value, [column], [order]);
  }

}
